module.exports = __webpack_public_path__ + "media/images/static/top/urban/left_photo_bg-ce8775ee96add7f3a3044f63489ac5d6.png";